module.exports = __webpack_public_path__ + "static/media/aboutme2.30b7f923.jpg";